export const texts = {
  DRAFT_INVOICES_PAGE_TITLE: "Draft invoices status",
  CANCEL_INVOICES_TEXT: "Cancel invoices",
  SUCCESSFUL_CANCELLATION_MESSAGE: "Invoices canceled successfully",
};
